module.exports = __webpack_public_path__ + "static/media/11_4.9ec4f33a.png";